import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { GET_DMX_COMPATIBLE_DEVICES } from './actionTypes';
import { getDmxCompatibleDevicesSuccess, getDmxCompatibleDevicesError } from './actions';

import { getDmxAPI } from '../../../api/dmx';

const dmxAPI = getDmxAPI();

function* getCompatibleDevices({ payload: { user, deviceId } }) {
  try {
    const response = yield call(dmxAPI.getCompatibleDevices, user.token, deviceId);
    yield put(getDmxCompatibleDevicesSuccess(response));
  } catch (error) {
    yield put(getDmxCompatibleDevicesError(error));
  }
}

export function* watchGetDmxCompatibleDevices() {
  yield takeEvery(GET_DMX_COMPATIBLE_DEVICES, getCompatibleDevices);
}

function* getDmxCompatibleDevicesSaga() {
  yield all([fork(watchGetDmxCompatibleDevices)]);
}

export default getDmxCompatibleDevicesSaga;
